/* =========================
   PRODUCT AREA CALCULATOR
========================= */

const quantityInput = document.getElementById('quantityInput');

if (quantityInput) {
  const btnMinus = document.getElementById('btn-minus');
  const btnPlus = document.getElementById('btn-plus');
  const lengthInput = document.getElementById('length_needed');
  const widthInput = document.getElementById('width_needed');
  const areaInput = document.getElementById('actual_area');
  const packsNeededSpan = document.getElementById('packs_needed');
  const calcPriceSpan = document.getElementById('calc-price');
  const coverSpan = document.getElementById('cover');
  const dataCoverageElement = document.getElementById('data-coverage');

  const calculatorReady =
    btnMinus &&
    btnPlus &&
    lengthInput &&
    widthInput &&
    areaInput &&
    packsNeededSpan &&
    calcPriceSpan &&
    coverSpan &&
    dataCoverageElement;

  if (calculatorReady) {
    // Store the original cover value
    const originalCover = parseFloat(coverSpan.textContent);

    // Flag to track whether quantity input value was changed programmatically
    let quantityChangedProgrammatically = false;

    // Store the initial price
    let initialPrice = parseFloat(
      calcPriceSpan.textContent.replace(/[^\d.]/g, '')
    );

    // Function to validate and format input as a number
    // with up to 2 decimal places
    function validateNumberInput(input) {
      let value = input.value.replace(/[^0-9.]/g, '');
      const parts = value.split('.');

      if (parts.length > 2) {
        parts.length = 2;
      }

      input.value = parts.join('.');
    }

    function resetLengthWidthAndAreaIfNecessary() {
      if (
        !quantityChangedProgrammatically &&
        (quantityInput.value === '' || quantityInput.value === '1')
      ) {
        lengthInput.value = '';
        widthInput.value = '';
        areaInput.value = '';
      }
    }

    function getCoverageValue() {
      return parseFloat(
        dataCoverageElement.getAttribute('data-coverage')
      );
    }

    function updateAreaAndPacks() {
      const lengthValue = parseFloat(lengthInput.value);
      const widthValue = parseFloat(widthInput.value);

      if (!isNaN(lengthValue) && !isNaN(widthValue)) {
        const area = lengthValue * widthValue;
        areaInput.value = area.toFixed(2);

        const coverageValue = getCoverageValue();

        if (!isNaN(coverageValue) && coverageValue !== 0) {
          const packsNeeded = Math.ceil(area / coverageValue);

          packsNeededSpan.textContent = packsNeeded;
          quantityInput.value = packsNeeded;
        } else {
          packsNeededSpan.textContent = '1';
          quantityInput.value = '1';
        }

        coverSpan.textContent = area.toFixed(2);
      } else {
        areaInput.value = '';
        packsNeededSpan.textContent = '1';
        quantityInput.value = '1';
        coverSpan.textContent = '0.00';
      }

      updateCalculatedPrice();
    }

    function updatePacksNeeded() {
      if (!quantityChangedProgrammatically) {
        packsNeededSpan.textContent =
          quantityInput.value === '0' ||
          quantityInput.value === ''
            ? '1'
            : quantityInput.value;

        updateCalculatedPrice();
        updateCoverFromQuantity();
      }
    }

    function updateCalculatedPrice() {
      const packsNeeded = parseInt(
        packsNeededSpan.textContent,
        10
      );

      const calculatedPrice = initialPrice * packsNeeded;

      calcPriceSpan.textContent = calculatedPrice.toFixed(2);
    }

    function updateCover() {
      const areaValue = parseFloat(areaInput.value);

      coverSpan.textContent =
        !isNaN(areaValue) && areaValue !== 0
          ? areaValue.toFixed(2)
          : '0.00';
    }

    function updateCoverFromQuantity() {
      const quantityValue = parseInt(quantityInput.value, 10);
      const coverageValue = getCoverageValue();

      if (
        !isNaN(quantityValue) &&
        !isNaN(coverageValue) &&
        coverageValue !== 0
      ) {
        const area = quantityValue * coverageValue;

        coverSpan.textContent = area.toFixed(2);
      } else {
        coverSpan.textContent = '0.00';
      }
    }

    // Add event listeners for length and width inputs
    lengthInput.addEventListener('input', function() {
      validateNumberInput(lengthInput);
      updateAreaAndPacks();
    });

    widthInput.addEventListener('input', function() {
      validateNumberInput(widthInput);
      updateAreaAndPacks();
    });

    // Add event listener to validate quantity input
    quantityInput.addEventListener('input', function() {
      validateNumberInput(quantityInput);
      quantityChangedProgrammatically = false;

      resetLengthWidthAndAreaIfNecessary();
      updatePacksNeeded();
      updateCoverFromQuantity();
    });

    quantityInput.addEventListener('change', function() {
      quantityChangedProgrammatically = true;
    });

    btnMinus.addEventListener('click', function() {
      if (
        parseInt(quantityInput.value, 10) >
        parseInt(quantityInput.min, 10)
      ) {
        lengthInput.value = '';
        widthInput.value = '';
        areaInput.value = '';

        quantityInput.dispatchEvent(
          new Event('input', { bubbles: true })
        );
      }
    });

    btnPlus.addEventListener('click', function() {
      if (
        parseInt(quantityInput.value, 10) <
          parseInt(quantityInput.max, 10) ||
        !quantityInput.max
      ) {
        lengthInput.value = '';
        widthInput.value = '';
        areaInput.value = '';

        quantityInput.dispatchEvent(
          new Event('input', { bubbles: true })
        );
      }
    });

    // Initial state
    quantityInput.value = '1';
    lengthInput.value = '';
    widthInput.value = '';
    areaInput.value = '';

    // Ensure initial price display is correct
    if (!isNaN(initialPrice)) {
      calcPriceSpan.textContent = initialPrice.toFixed(2);
    }

    // Keep this available in case another script currently relies on it
    void originalCover;
    void updateCover;
  }
}


/* =========================
   GLOBAL SHOPIFY CHAT
========================= */

document.addEventListener('click', function(event) {
  const trigger = event.target.closest('.chat-button');

  if (!trigger) return;

  event.preventDefault();

  function findChatButton(root) {
    root = root || document;

    const button = root.querySelector
      ? root.querySelector('button[aria-label="Chat"]')
      : null;

    if (button) {
      return button;
    }

    const elements = root.querySelectorAll
      ? root.querySelectorAll('*')
      : [];

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      if (element.shadowRoot) {
        const found = findChatButton(element.shadowRoot);

        if (found) {
          return found;
        }
      }
    }

    return null;
  }

  const chatButton = findChatButton(document);

  if (chatButton) {
    chatButton.click();
  }
});